export default {
  methods: {
    createSymbol(iconName, prefix = "fas") {
      let symbol = document.querySelector(
        "i[data-fa-symbol='" + iconName + "']"
      );
      if (symbol === null) {
        symbol = document.createElement("i");
        symbol.dataset.faSymbol = iconName;
        symbol.classList.add(prefix, "fa-" + iconName, "fa-fw");

        document.body.appendChild(symbol);
      }
      return symbol;
    },
  },
};
